import comp from "./GlobalMenuTray";
export default comp;
